// eslint-disable-next-line max-len

import { shortLanguages } from 'services/locale';

export const bluejackFrameUrl = `https://virtuals.jacktop.win/reverse-game/launchgameapiv1toapiv1?tokenAuth=<token>&clientId=<clientId>&game_id=<gameId>&lng=<lng>&providerId=1`;
export const bluejackClientId = 957;

export const formatBluejackLink = (token: string, gameId: string | number, lang: string) =>
  bluejackFrameUrl
    .replace('<token>', token)
    .replace('<gameId>', gameId.toString())
    .replace('<clientId>', bluejackClientId.toString())
    .replace('<lng>', shortLanguages?.[lang as keyof typeof shortLanguages]);

export const gamesOrder: string[] = [
  '11079',
  '11504',
  '11503',
  '11051',
  '11028',
  '11084',
  '11500',
  '11070',
  '11026',
  '11065',
  '911034',
  '911533',
  '911078',
  '911098',
  '11512',
];
